var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-grid',{attrs:{"column-num":_vm.schema.columnNum,"gutter":_vm.schema.gutter}},_vm._l((_vm.schema.grids),function(item,idx){return _c('van-grid-item',{key:idx,attrs:{"text":item.text}},[_c('van-icon',{staticStyle:{"margin-bottom":"5px"},attrs:{"slot":"icon","name":item.url,"size":_vm.schema.iconSize},slot:"icon"})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }